// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewer__image-editor[data-v-2fc01ba2]{z-index:10100;background-color:#000}`, "",{"version":3,"sources":["webpack://./components/viewer/ImageEditor.vue"],"names":[],"mappings":"AAEA,uCACE,aAAA,CACA,qBAAA","sourcesContent":["\n// Take full screen size ()\n.viewer__image-editor {\n  z-index: 10100;\n  background-color: black;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
